import { createRoot } from "react-dom/client";

import { shouldBootstrapApplication } from "@/authentication/shouldBootstrapApplication";
import "./index.css";

async function enableMocking() {
  if (import.meta.env.REACT_APP_ENABLE_MSW !== "true") {
    return;
  }

  const { worker } = await import("@/mocks/browser");
  return worker.start();
}

if (shouldBootstrapApplication()) {
  enableMocking().then(async () => {
    const { Root } = await import("./Root");
    const container = document.getElementById("root")!;
    const root = createRoot(container);
    root.render(<Root />);
  });
}
